import blogFetch from "./blog-fetch";

document.querySelectorAll( '.b-blog' ).forEach( ( block ) => {

	blogFetch( block );

} );
